import React, { useState, useEffect } from "react";
import Button from "@mui/material/Button";
import Stack from "@mui/material/Stack";
import Grid from "@mui/material/Grid";
import Link from "@mui/material/Link";
import Breadcrumbs from "@mui/material/Breadcrumbs";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import Box from "@mui/material/Box";
import AppBar from "@mui/material/AppBar";
import { useTheme } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import BorderColorOutlinedIcon from "@mui/icons-material/BorderColorOutlined";
import {
  IconButton,
  Tooltip,
  TableCell,
  Checkbox,
  TableRow,
  Autocomplete,
  Table,
  TableBody,
  TableHead,
  Paper,
  TableContainer,
} from "@mui/material";
import { useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { useStyles } from "../../assets/styles/Theme";
import Navbar from "../../components/common/Navbar";
import SearchAppBar from "../../components/common/search";
import {
  externalgetApi,
  externalpostApi,
} from "../../services/external/externalApis";
import SnackbarMessage from "../../components/common/SnackbarMessage";
import {
  CURRENCY_API_01,
  CURRENCY_API_02,
  CURRENCY_API_03,
  LOCATION_API_01,
  MAPLOCATION_API_01,
} from "../../api/ApiModel";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { CON_STATUS_ACTIVE } from "../../utils/sys/Constants";
function MapCurrency() {
  const [errors, setErrors] = useState({});
  const [error, setError] = useState(null);
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [openErrorSnackbar, setOpenErrorSnackbar] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [selectedRows, setSelectedRows] = useState([]); // To track selected rows
  const [rows1, setRows1] = useState([]);
  const [data, setData] = useState([]);
  const [data2, setData2] = useState([]);
  const SYS_USER = useSelector((state) => state.user) || {};
  const { COMPCODE, GROUPCODE, RESTCODE, USERREFCODE, USERNAME } =
    SYS_USER.USER_PARAM || {};
  const [selectedLOC, setSelectedLOC] = useState("");
  const [dataloc, setDataloc] = useState("");
  const navigate = useNavigate();
  const theme = useTheme();
  const styles = useStyles(theme);
  const [selectedItemDetails, setSelectedItemDetails] = useState({
    // GROUPCODE: "",
    // GROUPNAME: "",
  });

  const [searchText, setSearchText] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [snackbarOpen, setSnackbarOpen] = useState(false);

  console.log("filteredDatafilteredDatafilteredData", filteredData);

  const [snackbarSeverity, setSnackbarSeverity] = useState("success");
  const gotToPage = () => {
    navigate("/ViewLocations");
  };

  const handleSelectionloc = (newValue) => {
    setSelectedLOC(newValue);
    console.log("Selected location:", newValue);
    fetchData2(newValue); // Fetch data based on the selected location
    fetchData(newValue);
  };

  const handleErrorSnackbarClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorSnackbar(false); // Reset the snackbar state
  };

  useEffect(() => {
    fetchData();
    fetchData2();
  }, [selectedLOC]);

  //-------------------functions----------------

  const fetchData2 = async () => {
    try {
      const result = await externalgetApi(CURRENCY_API_01, "get", {
        COMPCODE,
        LOCCODE: selectedLOC.LOCCODE,
      });
      setData2(result || []); // Ensure the result is an array
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Failed to fetch data.");
    }
  };

  const [exchangeRates, setExchangeRates] = useState({});
  const [savedRates, setSavedRates] = useState("");

  // Load saved rates from session storage on mount
  useEffect(() => {
    const storedRates =
      JSON.parse(sessionStorage.getItem("exchangeRates")) || [];
    setSavedRates(storedRates);
  }, []);

  // Save rates to session storage
  const saveToSessionStorage = (rates) => {
    sessionStorage.setItem("exchangeRates", JSON.stringify(rates));
  };

  const handleInputChange = (currencyCode, value) => {
    setExchangeRates((prev) => ({
      ...prev,
      [currencyCode]: value, // Update the value based on user input
    }));
  };

  const handleAddRate = (row) => {
    const rate = exchangeRates[row.CURRENCYCODE] || "1"; // Default to "1" if the value is empty
    const newSavedRates = [...savedRates, { ...row, EXCHANGERATE: rate }];
    setSavedRates(newSavedRates);
    saveToSessionStorage(newSavedRates);

    // Optionally reset the value in the input field
    setExchangeRates((prev) => ({ ...prev, [row.CURRENCYCODE]: "1" }));
  };

  const handleDeleteRate = (index) => {
    const updatedRates = savedRates.filter((_, idx) => idx !== index);
    setSavedRates(updatedRates);
    saveToSessionStorage(updatedRates);
  };

  const menuItems = [
    {
      text: "Edit",
      icon: <BorderColorOutlinedIcon />,
      //   onClick: (GROUPCODE) => handleItemClick(GROUPCODE, "Edit"),
    },
  ];
  const handleConfirm = async () => {
    const payload = {
      mapcurrencyDt: savedRates.map((row) => ({
        basE_CURRENCYCODE: "LKR", // Replace with actual base currency code
        currencycode: row.CURRENCYCODE,
        currency: row.CURRENCY,
        currencY_RATIO: row.EXCHANGERATE,
      })),
      COMPCODE,
      LOCCODE: selectedLOC.LOCCODE,
      enuser: USERNAME, // Replace with actual user
    };

    try {
      console.log("Payload for API call:", payload);
      // Make the API call using your preferred method (e.g., Axios, Fetch)
      const response = await externalpostApi(CURRENCY_API_03, payload);
      console.log("Success:", response.data);

      setSnackbarMessage("Currency Updated Successfully!");
      setSnackbarSeverity("success");
      setOpenSnackbar(true);
      setSnackbarOpen(true);
      fetchData2();
      // Optionally display success feedback to the user (e.g., snackbar)
    } catch (error) {
      console.error("Error during API call:", error);
      // Optionally display error feedback to the user
    }
  };

  useEffect(() => {
    if (Array.isArray(dataloc) && dataloc.length > 0 && !selectedLOC) {
      setSelectedLOC(dataloc[0]); // Set the first item as the default
    }
  }, [dataloc]);

  const fetchData = async () => {
    setIsLoading(true);
    try {
      const result = await externalgetApi(CURRENCY_API_02, "get", {
        COMPCODE,
        LOCCODE: selectedLOC.LOCCODE,
      });
      setData(result || []); // Ensure the result is an array
      setFilteredData(result || []); // Initialize filtered data
    } catch (err) {
      console.error("Error fetching data:", err);
      setError("Failed to fetch data.");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (data) {
      setFilteredData(data);
    }
  }, [data]);

  useEffect(() => {
    if (!data || !searchText) {
      setFilteredData(data);
      return;
    }

    const filtered = data.filter((item) => {
      const currency = item.CURRENCY ? item.CURRENCY.toLowerCase() : "";
      const currencyCode = item.CURRENCYCODE
        ? item.CURRENCYCODE.toLowerCase()
        : "";

      return (
        currency.includes(searchText.toLowerCase()) ||
        currencyCode.includes(searchText.toLowerCase())
      );
    });
    setFilteredData(filtered);
  }, [searchText, data]);
  const handleSearchChange = (event) => {
    const value = event.target.value;
    setSearchText(value);
    const filtered = data.filter(
      (item) =>
        (item.CURRENCY &&
          item.CURRENCY.toLowerCase().includes(value.toLowerCase())) ||
        (item.DESCRIPTION &&
          item.DESCRIPTION.toLowerCase().includes(value.toLowerCase()))
    );
    setFilteredData(filtered);
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };
  useEffect(() => {
    const fetchData = async () => {
      try {
        const result = await externalgetApi(MAPLOCATION_API_01, "get", {
          COMPCODE,
          USERREFCODE,
          USERNAME,
          STS: CON_STATUS_ACTIVE, // Fetch only items where STS is 'A'
        });

        setDataloc(result); // Populate orderData with the updated array
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, []);

  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [filteredRows, setFilteredRows] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Fetch data from the API
        const result = await externalgetApi(LOCATION_API_01, "get", {
          COMPCODE,
          GROUPCODE,
          USERNAME,
          STS: CON_STATUS_ACTIVE,
        });
        setData(result);
        setFilteredRows(result);

        // Find the currency for the selected location code
        const selectedLocation = result.find(
          (item) => item.LOCCODE === selectedLOC.LOCCODE
        );
        if (selectedLocation) {
          setSelectedCurrency(selectedLocation.PREFCURRENCY); // Updated to use PREFCURRENCY
          console.log("Currency Code:", selectedLocation.PREFCURRENCY);
        } else {
          setSelectedCurrency("");
        }
      } catch (err) {
        console.error("Error fetching data:", err);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [COMPCODE, GROUPCODE, USERNAME]);

  return (
    <div>
      <Navbar />
      <AppBar sx={styles.AI_CustomAppBar1}>
        <Box sx={styles.AI_HeaderContainer}>
          <Grid container spacing={2}>
            <Grid item xs={12} md={6}>
              <Breadcrumbs
                sx={styles.AI_breadcrumbs2}
                // position="fixed"
                separator={<NavigateNextIcon fontSize="small" />}
              >
                <Link underline="none">Home</Link>
                <Link underline="none">Tax Management</Link>
                <Link underline="none">Map Currency</Link>
              </Breadcrumbs>
            </Grid>
          </Grid>
        </Box>
      </AppBar>
      <Box sx={styles.box_container_add}>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Box
              sx={styles.col_title}
              display={"flex"}
              alignItems={"center"}
              justifyContent="space-between"
            >
              <Typography variant="title" align="left">
                Map Currency
              </Typography>
              {/* <Stack direction="row" justifyContent="flex-end" spacing={2}> */}
              <Box
                sx={{
                  minWidth: {
                    md: "320px",
                    lg: "320px",
                    sm: "220px",
                    xs: "220px",
                  },
                }}
              >
                <Autocomplete
                  options={Array.isArray(dataloc) ? dataloc : []}
                  getOptionLabel={(option) => option.LOCATION || ""}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Location"
                      size="small"
                      variant="outlined"
                      fullWidth
                    />
                  )}
                  onChange={(event, newValue) => {
                    handleSelectionloc(newValue); // Ensure this updates the state correctly
                  }}
                  value={
                    Array.isArray(dataloc) && selectedLOC
                      ? dataloc.find(
                          (item) => item.LOCCODE === selectedLOC.LOCCODE
                        ) || null
                      : null
                  }
                  ListboxProps={{
                    style: {
                      maxHeight: 150,
                      backgroundColor: theme.palette.background.paper,
                    },
                  }}
                  noOptionsText={
                    <div
                      style={{
                        backgroundColor: theme.palette.background.paper,
                        padding: "8px",
                      }}
                    >
                      No options
                    </div>
                  }
                  loading={isLoading}
                />
              </Box>
              {/* </Stack> */}
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Box p={1} sx={styles.map_curr_col_1}>
              <Grid item xs={12} sm={12} md={12}>
                <Grid container spacing={2} p={1}>
                  {/* <Box sx={styles.col_title}> */}
                  <Grid item xs={12} sm={12} md={6}>
                    <Typography variant="title" fontWeight={600} align="left">
                      Currency
                    </Typography>
                  </Grid>
                  <Grid item xs={12} sm={12} md={6}>
                    <Stack
                      direction="row"
                      justifyContent="flex-end"
                      spacing={2}
                    >
                      <SearchAppBar
                        value={searchText}
                        onChange={handleSearchChange}
                      />
                    </Stack>
                  </Grid>{" "}
                  {/* </Box> */}
                </Grid>
              </Grid>
              <Box sx={styles.st_page_table2}>
                <TableContainer sx={styles.VI_ViewStyledPaper_Map_Curr}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="left"
                          sx={{
                            fontWeight: "bold",
                            maxWidth: "100px",
                            padding: "1",
                          }}
                        >
                          Currency Code
                        </TableCell>
                        <TableCell
                          align="left"
                          sx={{ fontWeight: "bold", padding: "1" }}
                        >
                          Currency
                        </TableCell>
                        <TableCell
                          align="center"
                          sx={{ fontWeight: "bold", maxWidth: "100px" }}
                        >
                          Exchange Rate
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {filteredData.length > 0 ? (
                        filteredData.map((row, index) => (
                          <TableRow key={index}>
                            {/* <TableCell align="left">{row.BASECURRENCY}</TableCell> */}
                            <TableCell
                              align="left"
                              sx={{ fontWeight: "bold" }}
                              padding="1"
                            >
                              {row.CURRENCYCODE}
                            </TableCell>
                            <TableCell align="left" padding="1">
                              {row.CURRENCY}
                            </TableCell>
                            <TableCell
                              sx={{ maxWidth: "100px" }}
                              align="right"
                              padding="1"
                            >
                              <TextField
                                id={`txtrate-${index}`}
                                size="small"
                                fullWidth
                                variant="outlined"
                                autoComplete="off"
                                value={exchangeRates[row.CURRENCYCODE || ""]} // Default to "1"
                                onChange={(e) =>
                                  handleInputChange(
                                    row.CURRENCYCODE,
                                    e.target.value
                                  )
                                }
                                inputProps={{
                                  inputMode: "decimal", // Ensures numeric keyboard on mobile
                                  pattern: "[0-9]*", // Allows only numeric values
                                }}
                              />
                            </TableCell>
                            <TableCell align="center" padding="none">
                              <Button
                                variant="contained"
                                sx={{
                                  background: theme.palette.primary.main,
                                  color: theme.palette.text.buttontxt,
                                  textTransform: "capitalize",
                                  width: "60px",
                                }}
                                onClick={() => handleAddRate(row)}
                              >
                                Add
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={4} align="center"></TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} sm={12} md={6}>
            <Grid item xs={12}>
              <Box
                p={1}
                sx={{
                  borderRadius: "4px",
                  boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,

                  height: {
                    xs: "32.5vh",
                    sm: "32.5vh",
                    md: "32.5vh",
                    lg: "32.5vh",
                    xl: "32.5vh",
                  },
                  overflowY: "auto",
                  overflowX: "auto",
                  "&::-webkit-scrollbar": {
                    width: "0.3em",
                    height: "0.3em",
                  },

                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: theme.palette.primary.main,
                    borderRadius: "2px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: theme.palette.primary.main,
                  },

                  background: theme.palette.background.paper,
                }}
              >
                <TableContainer component={Paper}>
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      my: 1,
                    }}
                  >
                    <Box
                      sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "space-between",
                        // width: "30%",
                      }}
                    >
                      <Typography variant="title" fontWeight={600} align="left">
                        Default Currency
                      </Typography>
                      <Typography variant="body1">
                        : {selectedCurrency}
                      </Typography>
                    </Box>
                    <Button
                      variant="contained"
                      sx={{
                        background: theme.palette.primary.main,
                        color: theme.palette.text.buttontxt,
                        textTransform: "capitalize",
                        width: "120px",
                      }}
                      onClick={handleConfirm}
                    >
                      Confirm
                    </Button>{" "}
                  </Box>

                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="left"
                          sx={{ fontWeight: "bold", maxWidth: "100px" }}
                        >
                          Currency Code
                        </TableCell>
                        <TableCell align="left" sx={{ fontWeight: "bold" }}>
                          Currency
                        </TableCell>
                        <TableCell align="right" sx={{ fontWeight: "bold" }}>
                          Exchange Rate
                        </TableCell>
                        <TableCell align="center" sx={{ fontWeight: "bold" }}>
                          Action
                        </TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {savedRates.length > 0 ? (
                        savedRates.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell align="left" sx={{ maxWidth: "100%" }}>
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Typography>{selectedCurrency}</Typography>
                                <ArrowForwardIcon />
                                <Typography>{row.CURRENCYCODE}</Typography>
                              </Box>
                            </TableCell>
                            <TableCell align="left">{row.CURRENCY}</TableCell>
                            <TableCell align="right">
                              {row.EXCHANGERATE}
                            </TableCell>
                            <TableCell align="center">
                              <Button
                                variant="contained"
                                sx={{
                                  background: theme.palette.error.main,
                                  color: theme.palette.text.buttontxt,
                                  textTransform: "capitalize",
                                  width: "60px",
                                }}
                                onClick={() => handleDeleteRate(index)}
                              >
                                Delete
                              </Button>
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={4} align="center"></TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>

            <Grid item xs={12} pt={2}>
              <Box
                p={1}
                sx={{
                  borderRadius: "4px",
                  boxShadow: `0px 0px 4px 0px ${theme.palette.input_field.stroke}`,
                  height: {
                    xs: "30vh",
                    sm: "30vh",
                    md: "30vh",
                    lg: "30vh",
                    xl: "30vh",
                  },
                  overflowY: "auto",
                  overflowX: "auto",
                  "&::-webkit-scrollbar": {
                    width: "0.3em",
                    height: "0.3em",
                  },

                  "&::-webkit-scrollbar-thumb": {
                    backgroundColor: theme.palette.primary.main,
                    borderRadius: "2px",
                  },
                  "&::-webkit-scrollbar-thumb:hover": {
                    backgroundColor: theme.palette.primary.main,
                  },

                  background: theme.palette.background.paper,
                }}
              >
                <Grid
                  container
                  justifyContent="space-between"
                  alignItems="center"
                  mb={2}
                  // pl={2}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      my: 1,
                    }}
                  >
                    <Typography variant="title" fontWeight={600} align="left">
                      Currency History
                    </Typography>
                  </Box>
                </Grid>
                <TableContainer component={Paper}>
                  <Table stickyHeader aria-label="simple table">
                    <TableHead>
                      <TableRow>
                        <TableCell
                          sx={{ fontWeight: "bold", maxWidth: "100px" }}
                        >
                          Code
                        </TableCell>
                        <TableCell sx={{ fontWeight: "bold" }} align="left">
                          Currency
                        </TableCell>
                        <TableCell
                          sx={{ fontWeight: "bold", maxWidth: "100px" }}
                          align="right"
                        >
                          Exchange Rate
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {data2.length > 0 ? (
                        data2.map((row, index) => (
                          <TableRow key={index}>
                            <TableCell align="left" sx={{ maxWidth: "100%" }}>
                              <Box
                                sx={{ display: "flex", alignItems: "center" }}
                              >
                                <Typography>{selectedCurrency}</Typography>
                                <ArrowForwardIcon />
                                <Typography>{row.CURRENCYCODE}</Typography>
                              </Box>
                            </TableCell>
                            <TableCell align="left">{row.CURRENCY}</TableCell>
                            <TableCell sx={{ maxWidth: "100px" }} align="right">
                              {row.CURRENCY_RATIO}
                            </TableCell>
                          </TableRow>
                        ))
                      ) : (
                        <TableRow>
                          <TableCell colSpan={4} align="center"></TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Grid>
          </Grid>
        </Grid>
      </Box>
      <SnackbarMessage
        open={snackbarOpen}
        handleClose={handleSnackbarClose}
        message={snackbarMessage}
        severity={snackbarSeverity}
      />
    </div>
  );
}

export default MapCurrency;
